export default __webpack_public_path__ + "static/media/scaleFasterBtn.cdf5a7ad.png";